import { useLayoutEffect, useState, useEffect, useCallback } from "react";
import DataGrid, {
  Column,
  HeaderFilter,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { AssetSubStatus, DefaultDateFormat } from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useLocation, useNavigate } from "react-router-dom";
import "./../../../App.css";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
} from "../../../helper/message";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";

export default function ViewAssetAcknowledgeComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const location = useLocation();
  const [assetInfo, setAssetInfo] = useState(null);

  useLayoutEffect(() => {
    document.querySelector(
      "#pageTitle"
    ).innerHTML = `View Asset Information & Specification`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetInfo(location?.state?.assetId);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetInfo = async (assetId) => {
    try {
      debugger;
      const Assetresponse = await assetService.getassetList(assetId);
      setAssetInfo(Assetresponse?.data[0] ?? null);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-header p-2">
            <h3 className="mainheading mb-0">Asset Information</h3>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Asset Name</label>
                  <p className="labelvalue">{assetInfo?.name ?? ""}</p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Group</label>
                  <p className="labelvalue">{assetInfo?.groupName ?? ""}</p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Category</label>
                  <p className="labelvalue">{assetInfo?.categoryName ?? ""}</p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Sub Category</label>
                  <p className="labelvalue">
                    {assetInfo?.subCategoryName ?? ""}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Project</label>
                  <p className="labelvalue">{assetInfo?.projectName ?? ""}</p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Location</label>
                  <p className="labelvalue">
                    {assetInfo?.assetLocationName ?? ""}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Description</label>
                  <p className="labelvalue">{assetInfo?.assetDesc ?? ""}</p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Asset Label No</label>
                  <p className="labelvalue">{assetInfo?.assetLabelNo ?? ""}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header p-2">
            <h3 className="mainheading mb-0">Specifications</h3>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-lg-8">
                <div className="row"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
